module.exports = __webpack_public_path__ + "img/level_5.401ed23e.svg";